import { QProfileHeader, QProfileItem, QProfileMenu, QLink, QThemeProvider } from '@kw/quokka-ui';
import { zendeskSSOUrls } from '../shared/zendeskUrls';

interface IProps {
  anchorEl: HTMLDivElement;
  handleClose: () => void;
}

export default function HelpDropDownMenu({ anchorEl, handleClose }: IProps) {
  const helpOpen = Boolean(anchorEl);
  const helpId = helpOpen ? 'help-popover' : undefined;

  const openInNewTab = url => {
    window.open(url, '_blank').focus();
  };

  return (
    <QThemeProvider>
      <QProfileMenu
        id={helpId}
        anchorEl={anchorEl}
        open={helpOpen}
        onClose={handleClose}
        header={<QProfileHeader primary="Help" />}
        aria-label="help drop down menu"
        items={[
          <QProfileItem
            key="documentation_center"
            component={QLink}
            onClick={() => {
              // redirect through SAML to documentation center https://qscout.zendesk.com/hc/en-us with brand QScout
              openInNewTab(zendeskSSOUrls.documentationCenter);
            }}
            disableRipple
            target="_blank"
          >
            {'Documentation Center'}
          </QProfileItem>,
          <QProfileItem
            key="customer_support"
            component={QLink}
            onClick={() => {
              // redirect through SAML to customer support https://qscout.zendesk.com/hc/en-us/requests with brand QScout
              openInNewTab(zendeskSSOUrls.customerSupport);
            }}
            disableRipple
            target="_blank"
          >
            {'Customer Support'}
          </QProfileItem>,
        ]}
      />
    </QThemeProvider>
  );
}
